import { createBrowserHistory } from "history";
import { forgotLastLocation } from "../_metronic/_helpers/RouterHelpers";
import { getFirebaseToken } from "../app/services/authService";

export default function setupAxios(axios, store, authClient) {
  var history = createBrowserHistory();
  axios.interceptors.request.use(
    async config => {
      try {
        // Try to get Firebase token first
        const token = await getFirebaseToken();
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('Token error:', err);
      }
      
      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use(
    res => res,
    err => {
      if (err.response?.status === 401) {
        history.push("/logout");
        window.location.href = window.location.href;
      }
      return Promise.reject(err);
    }
  );
}
